import { axios } from '@/utils/request'

const api = {

  master: '/master/bondApply',
}
// 列表
export function queryIdList (parameter) {
  return axios({
    url: api.master + '/list',
    method: 'get',
    params: parameter
  })
}

// 审核
export function apply (parameter) {
  return axios({
    url: api.master + '/apply',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 删除
export function deleteData (parameter) {
  return axios({
    url: api.master + '/delete',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

